export default __webpack_public_path__ + "static/tshirt-4a5ab41b574dfbd20b6692b059986256.png";